import { render, staticRenderFns } from "./GrecaGallery.vue?vue&type=template&id=24f8689b&scoped=true"
import script from "./GrecaGallery.vue?vue&type=script&lang=js"
export * from "./GrecaGallery.vue?vue&type=script&lang=js"
import style0 from "./GrecaGallery.vue?vue&type=style&index=0&id=24f8689b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f8689b",
  null
  
)

export default component.exports